/**
 * @description: 图片预加载
 * @param {*}
 * @return {*}
 */
import { setPicSize } from '@zz-common/zz-utils'
export const loadFirstImage = (imgSrc, w, h) => {
  if (imgSrc) {
    const firstImg = new Image()
    firstImg.src = setPicSize(imgSrc, w, h)
  }
}
export const getQuery = (name) => {
  const reg = new RegExp(`(^|[&|\\?])${name}=([^&|#]*)([&|#]|$)`)
  const hrefs = window.location.href.split('?').splice(1)
  if (hrefs.length > 0) {
    let r = null
    hrefs.forEach((v) => {
      if (reg.test(v)) {
        r = `?${v}`.match(reg)
      }
    })
    if (r !== null) return decodeURIComponent(r[2])
    return r
  }
  return null
}

export const getSysType = () => {
  let sys = 'unknown'
  if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    sys = 'ios'
  } else if (
    navigator.userAgent.indexOf('Android') > -1 ||
    navigator.userAgent.indexOf('Adr') > -1
  ) {
    sys = 'android'
  }
  return sys
}
//比较app版本号
export const versionCompare = (v1, v2) => {
  //将两个版本号拆成数组
  const arr1 = v1.split('.')
  const arr2 = v2.split('.')
  const minLength = Math.min(arr1.length, arr2.length)
  //依次比较版本号每一位大小
  for (let i = 0; i < minLength; i++) {
    if (parseInt(arr1[i]) != parseInt(arr2[i])) {
      return parseInt(arr1[i]) > parseInt(arr2[i]) ? 1 : -1
    }
  }
  // 若前几位分隔相同，则按分隔数比较。
  if (arr1.length == arr2.length) {
    return 0
  } else {
    return arr1.length > arr2.length ? 1 : -1
  }
}

// 多维数组转一维数组

export const flatten = (arr) =>
  arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatten(val) : val), [])

// $ 判断iphoneX及以上
export const isIphonex = (res) => {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
  }
  return false
}
// 加载js资源
export const loadJS = (url, cb) => {
  const head = window.document.getElementsByTagName('head')[0]
  const js = window.document.createElement('script')
  js.setAttribute('type', 'text/javascript')
  js.setAttribute('async', 'async')
  js.setAttribute('src', url)
  js.onload = cb && cb()
  head.appendChild(js)
}

/**
 * $ 格式化瑕疵
 * @param {*} params
 * @returns
 */
export const formatVal = (params) => {
  if (!params) return
  const reg1 = /\d+/g
  const result = params.match(reg1)
  const ms1 = result ? result[0] : undefined
  const reg2 = /[\u4e00-\u9fa5]/g
  const ms2 = params.match(reg2).join('')
  // 返回瑕疵的时候
  if (!ms1 && ms2) {
    if (ms2.indexOf('全新') > -1) {
      return { ms1: ms2.substring(0, 2), ms2: ms2.substring(2) }
    }
    return { ms1: ms2, ms2: '' }
  }
  return { ms1, ms2 }
}

// $ 解析url 链接参数
export const getUrlParams = (url) => {
  url = url || window.location.href
  if (url.indexOf('?') < 0) return {}
  return url
    .replace(/^.+?\?/, '')
    .replace(/#.+/, '')
    .split('&')
    .filter((param) => param)
    .reduce((obj, param) => {
      const i = param.indexOf('=')
      const t = [param.slice(0, i), param.slice(i + 1)]
      obj[t[0]] = decodeURIComponent(t[1]) // 对url中的值进行解码（对齐vue-router内部的处理）
      return obj
    }, {})
}
/**
 * 获取url参数
 * @param {*} name
 * @param {*} url
 */
export function getQueryString(name, url = '') {
  let link = location.href
  if (url) link = url
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(link) || ['', ''])[1].replace(
        /\+/g,
        '%20'
      )
    ) || ''
  )
}
